export default __webpack_public_path__ + "images/f13da36109fe01c601051bfd60545c4a.jpg";